import React, {useEffect, useState} from 'react';

import { IoClose } from "react-icons/io5";

const LogEntry = ({data, setDone}) => {

    let stime = 10;
    if( data.sub === "info"){
        stime = 30;
    }

    const [time, setTime] = useState(stime);

    useEffect(() => {
        let timer = setInterval(() => {
            setTime((time) => {
                if (time === 0) {
                    clearInterval(timer);
                    return 0;
                } else return time - 1;
            });
        }, 1000);
    }, []);

    if( time <= 0) {
        setActive(false)
        //console.log("DONE ################################# " + data.uid)
    }

    function setActive(a) {

        //data.done = true

        setDone(data.uid)
    }

    return (
        <div className={`logentry ${data.sub}`}

        >
            <div className={'logtext'} style={{
                opacity: 0.7,
            }}>
                {`${data.msg}`}
            </div>

            <div className="iconButton neutral"
                 onClick={() => setActive(false)}>
                <IoClose/>
            </div>
        </div>
    )
}

export default LogEntry
